const showHAV = () => {
    //eslint-disable-next-line
    $.showHAV();
};

export default {
    showHAV,
};
